import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { OrderSummary } from './OrderSummary'
import { OrderItemsLarge } from './OrderItemsLarge'
import { OrderItemsSmall } from './OrderItemsSmall'
import { OrderItemsEmptyContent } from './OrderItemsEmptyContent'
import { useContext } from './Context'

export const OrderItems = () => {
  const { document } = useContext()
  const items = document?.items

  if (isEmpty(items)) {
    return <OrderItemsEmptyContent />
  }

  return (
    <>
      <OrderItemsLarge items={items} />
      <OrderItemsSmall items={items} />

      <OrderSummary />
    </>
  )
}
